@if (barChartData?.length && maxChartValue) {
  <div class="bar-chart">
    @for (bar of paginatedChartData; track bar) {
      <div (click)="barClick.emit(bar)">
        <div class="value">{{ bar | misc: "getBarValue" : charInfo }}</div>
        <div
          class="bar"
          [ngStyle]="
            bar
              | misc
                : 'getBarStyle'
                : charInfo
                : maxChartValue
                : defaultChartHeight
          "
        ></div>
        <div class="label">{{ bar | misc: "getBarLabel" : charInfo }}</div>
      </div>
    }
  </div>
  @if (otherParams?.paginationData) {
    <div class="mt-2 donotprint">
      <gtapp-pagination-control
        [pageSize]="rows"
        [pageNum]="pageNum"
        [previous]="previousRows"
        [totalRows]="totalRows"
        (onChangePagination)="onChangePagination($event)"
      >
      </gtapp-pagination-control>
    </div>
  }
}
